import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { I1PositionsEdit } from "./edit";
import { I1PositionsNew } from "./new";
import { I1PositionsTable } from "./table";

export default function I1Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<I1PositionsEdit />} />
      <Route index element={<I1PositionsTable />} />
      <Route path="new" element={<I1PositionsNew />} />
    </Routes>
  );
}
